<template>
  <transition name="fortune-modal">
    <div class="fortune-modal-overlay" @click.self="close">
      <div class="fortune-modal-container">
        <div class="fortune-modal-header">
          <button class="fortune-modal-close-btn" @click="close">&times;</button>
        </div>
        <div class="fortune-modal-content">
          <template v-if="step === 1" v-animation:bottom.delay>
            <h3 class="fortune-modal-title">Колесо фортуны</h3>
            <wheel-fortune
              class="fortune-modal__wheel-fortune"
              image="/dist/img/ax-max-pro/wheel-fortune/fortune.svg"
              @win="setWin"
            ></wheel-fortune>
          </template>
          <template v-else-if="step === 2">
            <div class="fortune-modal-gift-result">
              <template v-if="gift === WHEEL_FORTUNE_PRIZE_MAP.tgStickerPack">
                <img class="fortune-modal-gift-result__img" src="/dist/img/ax-max-pro/wheel-fortune/tgStickerPack.png" alt="Стикерпак для телеграм Axoft">
                <p>Поздравляем! Сегодня ваш счастливый день: вы выиграли «Стикерпак для телеграм Axoft», скачать который можно по ссылке ниже.</p>
                <p>Пусть радость победы вдохновляет вас на новые свершения, улыбка не покидает ваше лицо весь день! Удачи вам и новых побед!</p>
                <a class="t-btn _green _big" href="https://t.me/addstickers/axoft_asol" target="_blank">Скачать стикерпак</a>
              </template>
              <template v-else-if="gift === WHEEL_FORTUNE_PRIZE_MAP.ozonGiftCertificate">
                <img class="fortune-modal-gift-result__img" src="/dist/img/ax-max-pro/wheel-fortune/ozonGiftCertificate.png" alt="Сертификат Ozon">
                <p>Поздравляем! Сегодня ваш счастливый день: вы выиграли «Сертификат Ozon на 3000руб». Сертификат будет направлен в течние трех дней на e-mail, указанный при регистрации.</p>
                <p>Пусть радость победы вдохновляет вас на новые свершения, улыбка не покидает ваше лицо весь день! Удачи вам и новых побед!</p>
              </template>
              <template v-else-if="gift === WHEEL_FORTUNE_PRIZE_MAP.loadAndShipBonus">
                <img class="fortune-modal-gift-result__img" src="/dist/img/ax-max-pro/wheel-fortune/loadAndShipBonus.png" alt="бонус 'Грузи и Увози'">
                <p>Поздравляем! Сегодня ваш счастливый день: вы выиграли «+10% к бонусу в акции “Грузи и Увози” в октябре». Для получения бонуса с вами свяжется ответственный менеджер.</p>
                <p>Пусть радость победы вдохновляет вас на новые свершения, улыбка не покидает ваше лицо весь день! Удачи вам и новых побед!</p>
              </template>
              <template v-else-if="gift === WHEEL_FORTUNE_PRIZE_MAP.yaPlus">
                <img class="fortune-modal-gift-result__img" src="/dist/img/ax-max-pro/wheel-fortune/yaPlus.png" alt="Подписка Яндекс Плюс">
                <p>Поздравляем! Сегодня ваш счастливый день: вы выиграли «Подписка Яндекс Плюс». Сертификат будет направлен в течение трех дней на e-mail, указанный при регистрации.</p>
                <p>Пусть радость победы вдохновляет вас на новые свершения, улыбка не покидает ваше лицо весь день! Удачи вам и новых побед!</p>
              </template>
              <template v-else-if="gift === WHEEL_FORTUNE_PRIZE_MAP.simpleWineGiftCertificate">
                <img class="fortune-modal-gift-result__img" src="/dist/img/ax-max-pro/wheel-fortune/simpleWineGiftCertificate.png" alt="Подарочный сертификат Simple Wine">
                <p>Поздравляем! Сегодня ваш счастливый день: вы выиграли «Подарочный сертификат Simple Wine». Для получения бонуса с вами свяжется ответственный менеджер.</p>
                <p>Пусть радость победы вдохновляет вас на новые свершения, улыбка не покидает ваше лицо весь день! Удачи вам и новых побед!</p>
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import AmpWheelFortune from "./amp-wheel-fortune.vue"
import { WHEEL_FORTUNE_PRIZE_MAP } from "@pages/axoft-maximum-pro/consts/amp"
import { observeNewAnimateBlocks } from "@src/libs/animate/scroll.animate"

export default {
  name: 'wheel-fortune-modal',
  components: {
    'wheel-fortune': AmpWheelFortune,
  },
  emits: ['close', 'win'],
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    gift: {
      type: String, // tgStickerPack | ozonGiftCertificate | loadAndShipBonus | yaPlus | simpleWineGiftCertificate
    }
  },
  mounted() {
    setTimeout(() => {
      observeNewAnimateBlocks()
    }, 1100)
  },
  data() {
    return {

    }
  },
  computed: {
    step() {
      return this.gift ? 2 : 1
    },
    WHEEL_FORTUNE_PRIZE_MAP() {
      return WHEEL_FORTUNE_PRIZE_MAP
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    setWin(gift) {
      this.$emit('win', gift)
    },
  }
}
</script>

<style lang="sass">
@import "~@src/sass/params"

.fortune-modal-enter-active, .fortune-modal-leave-active
  transition: opacity 0.3s ease

.fortune-modal-enter, .fortune-modal-leave-to
  opacity: 0

.fortune-modal-enter-active .fortune-modal-container,
.fortune-modal-leave-active .fortune-modal-container
  transition: transform 0.3s ease

.fortune-modal-enter .fortune-modal-container,
.fortune-modal-leave-to .fortune-modal-container
  transform: scale(0.95) translateY(-10px)

.fortune-modal-overlay
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  background-color: rgba(0, 0, 0, 0.5)
  display: flex
  justify-content: center
  align-items: center
  z-index: 1000

.fortune-modal-container
  background: white
  border-radius: 8px
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3)
  width: 100%
  max-width: 700px
  max-height: 90vh
  overflow-y: auto
  margin-inline: 20px

.fortune-modal-header
  display: flex
  justify-content: space-between
  align-items: center
  padding: 20px 20px 0

.fortune-modal-close-btn
  margin-left: auto
  background: none
  border: none
  font-size: 40px
  cursor: pointer
  color: #929292
  padding: 0
  width: 30px
  height: 30px
  display: flex
  align-items: center
  justify-content: center

.fortune-modal-close-btn:hover
  color: #374151

.fortune-modal-content
  display: flex
  flex-direction: column
  align-items: center
  padding: 0 102px 70px

  @media (max-width: $mobile-size)
    padding: 0 20px 20px

.fortune-modal-title
  font-size: 40px
  font-weight: 600
  text-align: center
  margin-bottom: 42px

  .fortune-modal-amp-wheel-fortune
    max-width: 500px

.fortune-modal__wheel-fortune
  aspect-ratio: 1 / 1
  max-width: 520px
  width: 100%
  height: 100%

.fortune-modal-gift-result
  display: flex
  flex-direction: column

  > p
    margin-top: 10px

  &__img
    width: 160px
    align-self: center
    margin-bottom: 30px

  > .t-btn
    align-self: center
    margin-top: 40px
</style>


// WEBPACK FOOTER //
// src/templates/pages/axoft-maximum-pro/components/modal/wheel-fortune-modal.vue